import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import ShimmerRouteKey, { isValidShimmerKey } from '../../constants/shimmer-keys';
import { ShimmerService } from '../../services/shimmer.service';

@Component({
  selector: 'app-shimmer',
  templateUrl: './shimmer.component.html',
  styleUrls: ['./shimmer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShimmerComponent implements OnInit, OnDestroy, OnChanges {
  @Input() set key(value: ShimmerRouteKey) {
    if (!value || !isValidShimmerKey(value)) {
      console.warn('Invalid shimmer key provided');
      return;
    }
    this._key = value;
  }
  get key(): ShimmerRouteKey {
    return this._key;
  }
  private _key!: ShimmerRouteKey;

  isLoading$: Observable<boolean>;
  public RouteKey = ShimmerRouteKey;

  constructor(private shimmerService: ShimmerService) {}

  ngOnInit(): void {
    if (!this.key) {
      throw new Error(`[ShimmerComponent] 'key' input is required`);
    }
    this.isLoading$ = this.shimmerService.loading$(this.key);
  }

  ngOnDestroy() {
    this.shimmerService.removeState(this.key);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['key']) {
      this.isLoading$ = this.shimmerService.loading$(this.key);
    }
  }

  handleError(error: any) {
    console.error('Error in ShimmerComponent:', error);
    this.shimmerService.hide(this.key);
    this.shimmerService.removeState(this.key);
  }
}
